import { oz } from '@weft/utils';

export const NetSuiteSyncInvoiceResponseSchema = oz.object({
  recordId: oz.string().or(oz.number()),
  tranId: oz.string(),
});

export type NetSuiteSyncInvoiceResponse = oz.TypeOf<typeof NetSuiteSyncInvoiceResponseSchema>;